import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "../../../environments/environment";

export const authConfig: AuthConfig = {
  issuer: `${environment.SSO_AUTHORITY}${environment.TENANT_ID}/v2.0`,
  tokenEndpoint: `${environment.SSO_AUTHORITY}${environment.TENANT_ID}/oauth2/v2.0/token`,
  redirectUri: environment.REDIRECT_URI,
  clientId: environment.CLIENT_ID,
  responseType: "code",
  // offline_access → Azure AD issues a refresh token alongside the access token
  scope: `openid profile email offline_access ${environment.SCOPE}`,
  requestAccessToken: true,
  // MS AAD v2.0: the issuer in returned tokens includes the tenant GUID but the
  // discovery doc issuer contains a literal {tenantid} placeholder — skip strict check
  skipIssuerCheck: true,
  strictDiscoveryDocumentValidation: false,
  requireHttps: environment.PRODUCTION,
  showDebugInformation: !environment.PRODUCTION,
  // Prevent the library from using sessionChecks which can cause false logouts
  sessionChecksEnabled: false,
  // After IDP logout, redirect back to the login page
  postLogoutRedirectUri: window.location.origin + '/login',
  // Proactively refresh 75% through the token lifetime (uses refresh token grant)
  timeoutFactor: 0.75,
};
